/**
 * @param {string} name
 */
export function getCookie(name: string) {
  const value = document.cookie
    .split(";")
    .map((e) => {
      const [name, value] = e.trim().split("=");
      return { name, value };
    })
    .find((e) => e.name === name)?.value;
  return value;
}
